<template>
    <layouts-header></layouts-header>
    <layouts-sidebar></layouts-sidebar>
    <div class="page-wrapper meter-opp">
        <div class="content">
            <div class="row">
                <div class="col-md-12">
                    <div class="contact-head">
                        <div class="row align-items-center">
                            <div class="col-sm-6">
                                <ul class="contact-breadcrumb">
                                    <li @click="handleBack" style="cursor: pointer;">
                                        <i class="ti ti-arrow-narrow-left"></i>
                                        <span class="back-btn">Back</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <Form ref="quoteForm" @submit="saveQuote" :validation-schema="schema" class="card">
                        <h4 class="mt-4 ms-4">Quote details</h4>

                        <div class="row mt-4 card-body">
                            <!-- Supplier -->
                            <div class="col-md-3">

                                <div class="form-wrap">
                                    <label class="col-form-label">
                                        Supplier
                                        <span class="text-danger">*</span>
                                    </label>
                                    <!-- Vee-Validate Field -->
                                    <Field name="supplier_id" v-model="form.supplier_id">
                                        <vue-select v-bind="field" :options="supplierOptions" v-model="form.supplier_id"
                                            placeholder="Select....." @select="myChangeEvent($event)" autocomplete="off"
                                            autocorrect="off" autocapitalize="off" spellcheck="false" />
                                    </Field>
                                    <!-- Error Message -->
                                    <ErrorMessage name="supplier_id" class="text-danger" />
                                </div>

                            </div>

                            <!-- Energy -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Product: <span class="text-danger">*</span></label>
                                    <Field name="energy" as="select" class="form-select" v-model="form.energy">
                                        <option value="" disabled>Select energy type</option>
                                        <option value="gas">Gas</option>
                                        <option value="elec">Electricity</option>
                                        <option value="water">Water</option>
                                    </Field>
                                    <ErrorMessage name="energy" class="text-danger" />
                                </div>
                            </div>

                            <!-- Term -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Term: <span class="text-danger">*</span></label>
                                    <div class="input-group">
                                        <Field name="term" type="text" class="form-control" v-model="form.term"
                                            @keypress="$utils.allowOnlyInteger" />
                                        <span class="input-group-text">year</span>
                                    </div>
                                    <ErrorMessage name="term" class="text-danger" />
                                </div>
                            </div>

                            <!-- Uplift -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Uplift:</label>
                                    <Field name="u4b_uplift" type="text" class="form-control" v-model="form.uplift"
                                        @keypress="$utils.allowOnlyNumbers" />
                                    <ErrorMessage name="u4b_uplift" class="text-danger" />
                                </div>
                            </div>

                            <!-- Price Book Version -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Price Book Version:</label>
                                    <Field name="price_book" type="text" class="form-control"
                                        v-model="form.price_book_version" />
                                </div>
                            </div>

                            <!-- Standing Charge -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Standing Charge:</label>
                                    <div class="input-group">
                                        <Field name="standing_charge" type="text" class="form-control"
                                            v-model="form.standing_charge" @keypress="$utils.allowOnlyNumbers" />
                                        <!-- <span class="input-group-text">p/day</span> -->
                                    </div>
                                </div>
                            </div>

                            <!-- Day Unit Rate -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Day Unit Rate - Unit Rate:</label>
                                    <div class="input-group">
                                        <Field name="DayUnitrate" type="text" class="form-control"
                                            v-model="form.day_unit_rate" @keypress="$utils.allowOnlyNumbers" />
                                        <!-- <span class="input-group-text">p/kWh</span> -->
                                    </div>
                                </div>
                            </div>

                            <!-- Night Unit Rate -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Night Unit Rate:</label>
                                    <Field name="NightUnitrate" type="text" class="form-control"
                                        v-model="form.night_unit_rate" @keypress="$utils.allowOnlyNumbers" />
                                </div>
                            </div>

                            <!-- Evening & Weekend -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Evening & Weekend:</label>
                                    <Field name="evening_weekend" type="text" class="form-control"
                                        v-model="form.evening_and_weekend" />
                                </div>
                            </div>

                            <!-- Full Description -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Full Description:</label>
                                    <Field name="full_description" as="textarea" class="form-control"
                                        v-model="form.full_description" rows="3" />
                                </div>
                            </div>

                            <!-- Price -->
                            <div class="col-md-3">
                                <div class="form-wrap">
                                    <label class="col-form-label ">Annual Cost:</label>
                                    <Field name="price" type="text" class="form-control" v-model="form.price"
                                        @keypress="$utils.allowOnlyNumbers" />
                                </div>
                            </div>

                            <!-- Buttons -->
                            <div class="col-12 text-end mt-4">
                                <button type="submit" class="btn btn-outline-secondary me-2 px-4">{{ isEdit ? "Update" :
                                    "Save" }}</button>
                                <!-- <button type="button" class="btn btn-primary px-4" @click="cancel_change"> Create
                                    new </button> -->
                                <button type="button" class="btn btn-outline-primary px-4" @click="handleBack"> Back
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
                <div class="table-responsive custom-table mt-4">
                    <quoted-prices-table :search-opp-query="searchOppQuery" :fromQuote="true" @editQuote="editQuote"
                        ref="oppTable"></quoted-prices-table>
                </div>
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="datatable-length"></div>
                    </div>
                    <div class="col-md-6">
                        <div class="datatable-paginate"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { ref, reactive, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Form, Field, ErrorMessage, defineRule } from "vee-validate";
import * as Yup from "yup";

export default {
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const oppTable = ref()
        const searchOppQuery = ref("")
        const isEdit = ref(false)
        const quoteForm = ref(null); // for template ref

        const form = ref({
            opportunity_id: route.query.opp_Id || null,
            supplier_id: "",
            energy: "",
            term: "",
            uplift: "",
            price_book_version: "",
            standing_charge: "",
            day_unit_rate: "",
            night_unit_rate: "",
            evening_and_weekend: "",
            full_description: "",
            price: "",
            comment: ""
        });

        const schema = Yup.object().shape({
            supplier_id: Yup.string()
                .trim()
                .required("Supplier is required"),

            energy: Yup.string()
                .trim()
                .required("Energy is required"),

            term: Yup.number()
                .typeError("Term must be a number")
                .required("Term level is required")
                .min(1, "Term must be between 1 to 5")
                .max(5, "Term must be between 1 to 5"),
        });

        const supplierOptions = ref([])

        const saveQuote = async () => {

            let response;

            if (isEdit.value) {
                response = await store.dispatch('opportunity/updateQuote', form.value);
            } else {
                response = await store.dispatch('opportunity/createQuote', form.value);
            }
            if (response?.status) {
                cancel_change()
                if (oppTable.value) {
                    oppTable.value.fetchOpportunities()
                }
            }

        };

        const cancel_change = () => {
            form.value = {
                opportunity_id: route.query.opp_Id || null,
                ...Object.fromEntries(Object.keys(form.value)
                    .filter(key => key !== 'opportunity_id')
                    .map(key => [key, ""]))
            };
            isEdit.value = false;
            quoteForm.value?.resetForm();
        };

        const handleBack = () => {
            router.back();
        }

        const myChangeEvent = (event) => {
            if (event.id === 'null') {
                form.value.supplier_id = null;
            }
        }

        const editQuote = (quote) => {
            Object.assign(form.value, quote);
            isEdit.value = true
        }


        onMounted(async () => {
            const data = await store.dispatch('opportunity/fetchOpportunityOptions');
            supplierOptions.value = [
                { id: 'null', text: 'Select....', original: null },
                ...data?.supplier?.map(item => ({
                    id: item.id,
                    text: item.name,
                    original: item,
                }))
            ];
        })

        return {
            form,
            saveQuote,
            cancel_change,
            handleBack,
            searchOppQuery,
            supplierOptions,
            myChangeEvent,
            editQuote,
            isEdit,
            oppTable,
            schema,
            quoteForm
        };
    },
};
</script>

<style scoped>
.card {
    border-radius: 8px;
}

.form-control,
.input-group-text {
    height: 42px;
}

.btn {
    padding: 8px 16px;
    font-size: 14px;
}

.col-form-label {
    padding-top: calc(0.375rem + 1px);
}

.back-btn {
    color: #6F6F6F;
    font-size: 16px;
    border: none;
    background-color: transparent;
}

li i {
    color: #E41F07;
    margin-right: 5px;
    border: 1px solid #E41F07;
    border-radius: 50%;
    padding: 3px;
}
</style>